module.exports = __webpack_public_path__ + "img/bike_station_enabled.39e936aa.svg";